/* eslint-disable @typescript-eslint/typedef */
import { createSlice } from '@reduxjs/toolkit';

import {
  MemberState,
  SetMemberPayload,
  SetMembersPayload,
  SetUnassignedMembersPayload
} from '../../../types/state/member.types';

export const initialState: MemberState = {
  member: undefined,
  members: [],
  unassignedMembers: []
};

const MemberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMember: (state, action: SetMemberPayload): void => {
      state.member = action.payload;
    },
    setMembers: (state, action: SetMembersPayload): void => {
      state.members = action.payload;
    },
    setUnassignedMembers: (state, action: SetUnassignedMembersPayload): void => {
      state.unassignedMembers = action.payload;
    }
  }
});

export const { setMember, setMembers, setUnassignedMembers } = MemberSlice.actions;

export default MemberSlice.reducer;
